import { render } from "./AddPlayers.vue?vue&type=template&id=21512ef3"
import script from "./AddPlayers.vue?vue&type=script&lang=ts"
export * from "./AddPlayers.vue?vue&type=script&lang=ts"

import "./AddPlayers.vue?vue&type=style&index=0&id=21512ef3&lang=css"
script.render = render

export default script